import { useState } from 'react';

export const useTags = (initialTags = [], availableTags = []) => {
  const [tags, setTags] = useState(initialTags);
  const [atags, setAtags] = useState(availableTags);

  // addTag
  const addTag = (tag) => {
    setTags([...tags, tag]);
    let newAtags = atags.filter(function (item) {
      return item !== tag;
    });
    setAtags(newAtags);
  };

  // deleteTag
  const deleteTag = (tag) => {
    setAtags([...atags, tag]);
    let newtags = tags.filter(function (item) {
      return item !== tag;
    });
    setTags(newtags);
  };

  return {
    //* Properties
    tags,
    atags,

    //* Methods
    addTag,
    deleteTag,
  };
};
